window.onscroll = function () {
  const headerHeight = document.querySelector(".collection-image-with-title").offsetHeight + 40;
  if (this.scrollY >= headerHeight && this.scrollY < document.querySelector("#CollectionLoop").scrollHeight) {  
    document.querySelector(".popout--group").classList.add("fixed-header");
  }
  else{
    document.querySelector(".popout--group").classList.remove("fixed-header");
  }
};


const filterButton = document.querySelector(".popout__toggle--filters");
const collectionProducts = document.querySelector(".collection__products");


if (collectionProducts) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const collectionList = collectionProducts.querySelector("#CollectionLoop");
        const filterSidebar = collectionProducts.querySelector('#filter-groups');
        filterSidebarClassList(filterSidebar, collectionList);

        filterButton && filterButton.addEventListener("click", () => {
          setTimeout(() => {
            filterSidebarClassList(filterSidebar, collectionList);
          }, 50);
        });
        
      }
    });
  });

  observer.observe(collectionProducts, { childList: true, subtree: true });
}

function filterSidebarClassList(filter, collection) {
  if(filter && filter.classList.contains("expanded")) {
    collection.classList.add('product-grid-3');
  }else{
    collection.classList.remove('product-grid-3');
  }
}
